module.exports = __webpack_public_path__ + "static/img/instagram.86de83d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/placeholders/instagram.png
// module id = owpC
// module chunks = 31